import { useCallback } from "react";

import Button from "@/components/Atoms/Button";
import Typography from "@/foundation/Typography/V2";

import * as actions from "@/redux/BootCampReducer";

import { classNameGenerator, clsx } from "@/utils";

import styles from "./PreConsultationSection.module.scss";
import { useAppSelector, useAppDispatch } from "@/hooks";

interface PreConsultationSectionProps {
    variant?: string;
}

const PreConsultationSection: React.FC<PreConsultationSectionProps> = ({ variant = "" }) => {
    const cls = classNameGenerator(styles);
    const dispatch = useAppDispatch();

    const { data } = useAppSelector((state) => state.bootCamp);

    if (!data?.preConsultation) {
        return <></>
    }
    
    const { currencySymbol, price, ctaText, upperTitle, title } = data?.preConsultation
    const setShowBookSlotModal = useCallback(
        (value: any) => {
            dispatch(actions.setShowBookSlotModal(value));
        },
        [dispatch]
    );
    const modalTitle = `${title} ${currencySymbol} ${price}`
    const stripTitle =
        `Not ready to commit to a plan yet? Speak to our Nutritionist for just ${currencySymbol} ${price}`;
    const description = "Once enrolled, download the Shyft app to attend or reschedule your consultations"


    return (
        <section className={clsx(cls("callbackStrip"), cls(variant))}>
            <div className={cls("container")}>
                <div className={cls("leftSection")}>
                   {currencySymbol && price!== null && <Typography
                        variant="heading3"
                        className={cls("title")}
                        dangerouslySetInnerHTML={{
                            __html: stripTitle
                        }}
                    />}
                    <Typography
                        variant="heading4"
                        className={cls("description")}
                        dangerouslySetInnerHTML={{
                            __html: description
                        }}
                    />
                </div>
                <div className={cls("rightSection")}>
                    <Button
                        variant="outline"
                        className={cls("actionButton")}
                        onClick={() => setShowBookSlotModal({
                            upperTitle,
                            heading: modalTitle,
                            showSubtitle: false,
                            packageData: data?.preConsultation,
                            showTnc: false
                        })}
                    >
                        {ctaText}
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default PreConsultationSection;
